module.exports = __webpack_public_path__ + "media/images/certificate-template-c8fa8025.png";